export default __webpack_public_path__ + "soccer-ball-variant.png";